import { useTranslation } from 'react-i18next';
import React, { useRef, useEffect, useState } from 'react';

import { Select, MenuItem } from '@material-ui/core';

import { update } from '../../../Functions/admin';
import { getReports } from '../../../Functions/reporting';
import { useAppContext } from '../../../Context/App/Provider';

import './ReportSelect.css';



export default function ReportSelect({ reports, setReports, loading, selectedReport, setSelectedReport, type }) {
  const { t } = useTranslation();

  const [tmpReports, setTmpReports] = useState(reports);
  const [reportsOpen, setReportsOpen] = React.useState(false);
  const [{ settings, sidebar, user }, appDispatch] = useAppContext();

  const handleUpdateFavorite = (e, report) => {
    e.preventDefault();

    const favorite = { reportId: report };
    let tmpArray = new Array();

    for (const rep of tmpReports) {
      const tmpRep = {
        ...rep
      }
      if (rep.id == report) {
        if (rep.favoriteId)
          tmpRep.favoriteId = null;
        else
          tmpRep.favoriteId = 'fake';
      }
      tmpArray.push(tmpRep);
    }
    setTmpReports(tmpArray);
    try {
      update({ type: 'favorite', favorite }).then(res => {

        getReports().then(rep => {
          if (rep && rep.success) {
            setReportsOpen(true);
            // setTmpReports(rep.reports);
          }
          else {
            setTmpReports(rep.reports);
          }
        });
      });
    }
    catch (error) {
      console.log("681 - error=", error);
    }
  };

  // useEffect(() => {
  // }, [tmpReports, reports, t]);

  // console.log("......");

  // console.log("64 - tmpReports=", tmpReports);
  // console.log("65 - settings=", settings);
  // console.log("65 - type=", type);
  // console.log("67 - selectedReport=", selectedReport);
  // console.log("68 - savSelectedReport=", savSelectedReport);

  // disabled={loading || !reports || (reports && reports.length === 0)}
  // console.log("71 - loading=", loading);
  // console.log("71 - reports && reports.length=", reports && reports.length);

  let reportName = '';
  if (selectedReport) {
    for (const report of tmpReports) {
      if (report.id == selectedReport) {
        reportName = report.name;
      }
    }
  }

  return (
    <div>
      <Select className="sidebar__select"

        title={selectedReport ? reportName : ''}

        style={{
          display: "flex",

          width: '100 %',
          height: '34px',
          padding: '0 8px',
          maxWidth: '100%',
          outline: '0',
          // cursor: 'pointer',
          fontSize: '12px',
          fontWeight: '600',
          fontFamily: 'inherit',

          transition: '0.25s',
          color: 'rgb(var(--accent-color))',
          borderRadius: 'var(--radius-small)',
          backgroundColor: 'var(--select-bg)',
          border: '0 px solid var(--separation-color-light)',

          opacity: (loading || !reports || (reports && reports.length === 0)) ? '0.4' : '1',
          cursor: (loading || !reports || (reports && reports.length === 0)) ? 'not-allowed' : 'pointer'

        }}

        id='report_selecter'
        variant='outlined'

        open={reportsOpen}
        onClose={() => {
          if (setReports)
            setReports(tmpReports);

          setReportsOpen(false);
        }}
        onOpen={() => setReportsOpen(true)}

        disabled={loading || !reports || (reports && reports.length === 0)}
        labelWidth={0}

        value={selectedReport ? selectedReport : 'choose'}

        onChange={e => {
          if (e.nativeEvent.target.className !== "material-icons-round") {
            setReportsOpen(false)
            setSelectedReport(e.target.value)
          }
        }}

        renderValue={value => {
          if (value === "choose") {
            return (
              <span
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  textAlign: 'left',
                  fontSize: '15px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                  transition: '0.25s',
                  color: 'rgb(var(--accent-color))',

                }}>{t('reporting.report.choose')}
              </span>
            )
          }
          return (
            <span
              style={{
                width: "100%",
                maxWidth: "100%",
                textAlign: 'left',
                fontSize: '15px', fontWeight: '600', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                transition: '0.25s',
                color: 'rgb(var(--accent-color))',

              }}>{reportName}
            </span>
          )
        }}
      >
        <MenuItem value="choose" style={{ display: 'none' }}>{t('reporting.report.choose')}</MenuItem>

        {tmpReports && tmpReports.length > 0 ? (
          tmpReports.sort(function (a, b) {
            if (a.favoriteId && b.favoriteId) {
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              if (b.name.toLowerCase() < a.name.toLowerCase()) {
                return 1;
              }
            }
            else if (a.favoriteId && !b.favoriteId) {
              return -1;
            }
            else if (!a.favoriteId && b.favoriteId) {
              return 1;
            }
            else if (!a.favoriteId && !b.favoriteId) {
              if (a.language === settings.lang && b.language === settings.lang) {
                if (a.name.toLowerCase() < b.name.toLowerCase()) {
                  return -1;
                }
                if (b.name.toLowerCase() < a.name.toLowerCase()) {
                  return 1;
                }
              }
              else if (a.language === settings.lang && b.language !== settings.lang) {
                return -1;
              }
              else if (a.language !== settings.lang && b.language === settings.lang) {
                return 1;
              }
            }
            return 0;
          }).map((report, key) => {

            if (report.type === type) {

            return (
              <MenuItem
                value={report.id}
                name={report.name}

                style={{
                  paddingLeft: '6px',
                  paddingRight: '20px',
                  //lineHeight: '24px',
                  display: 'flex'
                  // lineHeight: '0'
                }}
              //data-subtext="<span class='leftMen pull-left'>Sub Text</span>"
              >
                <span
                  className={"material-icons"}
                  title={t('global.favorite')}
                  style={{
                    textAlign: 'left',
                    width: '8%',
                    fontSize: '18px',
                    color: report.favoriteId === null ? 'rgb(var(--nofavorite-color))' : 'rgb(var(--favorite-color))'
                  }}
                  onClick={(e) => {
                    //console.log("6785 - e=", e, report.id);
                    e.stopPropagation();
                    handleUpdateFavorite(e, report.id)
                  }}
                >
                  {report.favoriteId === null ? 'star_border' : 'star'}
                </span>

                <span
                  style={{
                    width: "92%",
                    maxWidth: "100%",
                    textAlign: 'left',
                    fontSize: '14px', fontWeight: '400', fontFamily: "'Open Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
                    transition: '0.25s',
                    color: 'initial;'
                  }}
                >{report.name}
                </span>

              </MenuItem >
            )
          }
          }
          )

        ) : (
          <div>
          </div>
        )}
      </Select>
    </div>);
}
